module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_hoor-01df1650ca921b08adcf40cb64ef8ca7.png";